<script lang="ts">
import ClientStateFilterList from '../components/ClientStateFilterList.vue';

/** Cluster Issuers list. Client-side state filtering - see ClientStateFilterList. */
export default { name: 'ListCertManagerClusterIssuer', extends: ClientStateFilterList };
</script>
